<template>
  <div class="chi-sigpad-wrapper" :style="{
    height: height + 'px',
    width: width + 'px'
  }">
    <div :style="{width: Math.max(0, width - 32) + 'px'}" @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup" @touchstart="mousedown" @touchmove="mousemove" @touchend="mouseup" class="chi-sigpad" id="sigpad"></div>
    <div class="chi-sigpad-buttons">
      <kendo-button :sprite-css-class="'chi-icon-ok'" @click.prevent="ok" class="chi-sigpad-button chi-button-success" role="button" title="Confirm and submit signature"></kendo-button>
      <kendo-button :sprite-css-class="'chi-icon-cancel'" @click.prevent="clear" class="chi-sigpad-button chi-button-danger" role="button" title="Clear signature area"></kendo-button>
    </div>
  </div>
</template>

<style lang="scss">
.chi-sigpad-wrapper {
  background: white;
  border-color: rgba(0, 0, 0, 0.08);
  border-radius: 2px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  color: #656565;
  float: left;
  margin: 0.5em;
  overflow: auto;
  position: relative;
  &>.chi-sigpad {
    height: 100%;
    float: left;
  }
  &>.chi-sigpad-buttons {
    height: 100%;
    float: right;
    width: 30px;
    &>.k-button {
      background-color: transparent;
      background-image: none;
      clear: both;
      display: block;
      height: 50%;
      margin: 0;
      width: 100%;
      &:first-child {
        border-radius: 0 2px 0 0;
      }
      &:last-child {
        border-radius: 0 0 2px 0;
      }
    }
  }
}
</style>

<script>
import $ from 'jquery';
import {Button} from '@progress/kendo-buttons-vue-wrapper';

var Path = kendo.drawing.Path;
var Point = kendo.geometry.Point;

export default {
  name: 'SigPad',
  components: {
    'kendo-button': Button
  },
  methods: {
    clear: function () {
      this.$options.path = null;
      this.$options.sigpad.clear();
    },
    mousedown: function (event) {
      var path = this.$options.path =
        new Path({stroke: {
          color: '#646464',
          lineCap: 'round',
          lineJoin: 'round',
          width: 2
        }});
      var offset = this.$options.element.offset();
      var point =
        new Point(event.pageX - offset.left, event.pageY - offset.top);
      path.moveTo(point).lineTo(point);
      this.$options.sigpad.draw(path);
    },
    mousemove: function (event) {
      if (!this.$options.path)
        return;
      var offset = this.$options.element.offset();
      this.$options.path.lineTo(
        new Point(event.pageX - offset.left, event.pageY - offset.top)
      );
    },
    mouseup: function () {
      this.$options.path = null;
    },
    ok: function () {
      var self = this;
      var sigpad = this.$options.element;
      kendo.ui.progress(sigpad.parent(), true);
      window.setTimeout(complete, 5000);
      function complete() {
        kendo.ui.progress(sigpad.parent(), false);
      }
      kendo.drawing
        .drawDOM(sigpad)
        .then(function (data) {return kendo.drawing.exportImage(data)})
        .done(function (data) {
          self.send_file(data.substring(22), complete);
        });
    },
    send_file: function (data, callback) {
      var socket = this.$root.$options.socket;
      var filename = 'signature.' + Date.now() + '.png';
      var decoded = atob(data);
      var len = decoded.length;
      var binary = new Uint8Array(len);
      for (var i = len - 1; i >= 0; --i)
        binary[i] = decoded.charCodeAt(i);
      var message = new FormData();
      message.set(
        'file', new Blob([binary.buffer], {type: 'image/png'}), filename
      );
      var req = new XMLHttpRequest()
      req.open('POST', '/upload?T=' + this.$root.token);
      req.onerror = function () {
        console.error('Failed to upload signature file');
        callback();
      };
      req.onload = function () {
        socket.emit('file-upload', {name: filename});
        socket.emit('change', {id: 'sigpad', value: filename});
        socket.emit('click', {id: 'sigpadcomplete'});
        callback();
      };
      req.send(message);
    }
  },
  mounted: function () {
    var ems;
    this.$options.element = $('#sigpad');
    this.$options.path = null;
    this.$options.sigpad =
      kendo.drawing.Surface.create(this.$options.element);
    ems = (typeof this.height === 'string' && this.height.endsWith('em'));
    this.height = parseInt(this.height, 10) * (ems ? 14 : 1);
    ems = (typeof this.width === 'string' && this.width.endsWith('em'));
    this.width = parseInt(this.width, 10) * (ems ? 14 : 1);
  },
  props: {
    height: {default: '150px'},
    width: {default: '500px'}
  }
};
</script>
